<template>
  <div>
    <div class="logo">
      <img src="../assets/GreenCrossLogo.jpg" />
    </div>
    <h1 class="SiteHeading">
      Voucher Processing
    </h1>
  </div>
</template>

<script>

export default {
  name: "RwvHeader",
  async created() {
//  console.log("header")
  }
};
</script>
